import "../../../assets/styles/chips-input.scss";
import React, { useEffect, useState, useContext } from "react";
import { WithContext as ReactTags } from "react-tag-input";
import UserContext from "../../../services/user/user";
import messages_de from "../../../translations/de.json";
import messages_en from "../../../translations/en.json";
import messages_es from "../../../translations/es.json";
import messages_fr from "../../../translations/fr.json";

const ChipsInput = ({
  name,
  setValue,
  label,
  initValue,
  required = false,
  type = "text",
  disabled = false,
  tooltip = false,
  tooltipMessage,
}) => {
  const [tags, setTags] = useState([]);
  const [vals, setVals] = useState(
    typeof initValue === "undefined" ? "" : initValue === null ? "" : initValue
  );
  const [error, setError] = useState("");

  const messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr,
  };

  const KeyCodes = {
    semiColon: 186,
    semiColon_DE: 59,
    enter: 13,
  };

  const delimiters = [KeyCodes.semiColon, KeyCodes.enter];

  const { lang } = useContext(UserContext);

  useEffect(() => {
    let arr = [];
    for (const text in tags) {
      arr.push(tags[text].text);
    }
    setVals(arr.join(";"));
  }, [tags]);

  useEffect(() => {
    if (vals !== "") {
      var arr = vals.split(";");
      let initTags = [];
      for (const text in arr) {
        initTags.push({
          id: arr[text],
          text: arr[text],
        });
      }
      setTags(initTags);
    }
  }, []);

  useEffect(() => {
    setValue(vals, name);
  }, [vals]);

  const handleDelete = (i) => {
    setTags(tags.filter((tag, index) => index !== i));
  };

  const handleAddition = (tag) => {
    let arr = [];
    for (const text in tags) {
      arr.push(tags[text].text);
    }

    if (/^[0-9]+([;][0-9]+)?$/.test(tag.text) && arr.toString().length <= 255) {
      setTags([...tags, tag]);
    } else {
      setError("exceedLength");
    }
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const handleTagClick = (index) => {
    // console.log("The tag at index " + index + " was clicked");
  };

  // document.addEventListener("keypress", function (event) {
  //   console.log(event);
  // });

  const textValidation = (e) => {
    if (!/^[0-9]+([;][0-9]+)?$/.test(e) && e.length > 0) {
      setError("invalidInput");
    } else if (e.length >= 255) {
      setError("exceedLength");
    } else {
      setError("");
    }
  };

  return (
    <div>
      <div
        style={{
          background: "#EDEEF0",
          borderRadius: "6px",
          padding: "5px",
          width: "100%",
        }}
      >
        <ReactTags
          tags={tags}
          delimiters={delimiters}
          handleDelete={handleDelete}
          handleAddition={handleAddition}
          handleDrag={handleDrag}
          handleTagClick={handleTagClick}
          inputFieldPosition="inline"
          name={name}
          placeholder=""
          allowAdditionFromPaste
          maxLength="255"
          handleInputChange={textValidation}
        />
      </div>
      <span className="chips-input-error">
        {error === "invalidInput"
          ? messages[lang]["webIDs.invalidInput"]
          : error === "exceedLength"
          ? messages[lang]["webIDs.lengthExceed"]
          : null}
      </span>
    </div>
  );
};
export default ChipsInput;
